import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {Redirect} from 'react-router';

import ErrorMessage from './ErrorMessage';
import GraphQlError from './GraphQlError';

class Error extends PureComponent {
  render() {
    const {error, type} = this.props;
    let errorDisplay = error;
    let graphQlErrors = [];

    if (!error) {
      return null;
    }

    if (typeof error === 'string') {
      errorDisplay = {customError: {message: error}};
    }

    if (errorDisplay.graphQLErrors) {
      graphQlErrors = error.graphQLErrors.map((graphQLError, index) => (
        <GraphQlError key={index} color={type}>
          {graphQLError}
        </GraphQlError>
      ));

      for (const graphQLError of errorDisplay.graphQLErrors) {
        if (graphQLError.name === 'AuthError') {
          return <Redirect to="/login/redirect" />;
        }
      }
    }

    return (
      <div>
        {graphQlErrors}

        <ErrorMessage color={type}>{errorDisplay.networkError}</ErrorMessage>
        <ErrorMessage color={type}>{errorDisplay.authError}</ErrorMessage>
        <ErrorMessage color={type}>{errorDisplay.customError}</ErrorMessage>
      </div>
    );
  }
}

Error.propTypes = {
  error: PropTypes.any,
  type: PropTypes.string,
};

Error.defaultProps = {
  type: 'danger',
};

export default Error;
